import { render, staticRenderFns } from "./addresList.vue?vue&type=template&id=04e9df52&scoped=true"
import script from "./addresList.vue?vue&type=script&lang=js"
export * from "./addresList.vue?vue&type=script&lang=js"
import style0 from "./addresList.vue?vue&type=style&index=0&id=04e9df52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e9df52",
  null
  
)

export default component.exports